
































































































import Vue from 'vue';

export default Vue.extend({
  name: 'FirstStep',
  data: () => ({
    step: {
      name: '',
      phone: '',
      direction: '',
      bank: '',
      account: '',
      route: '',
      swift: '',
      code: '',
      country: '',
      city: '',
    },
  }),
  methods: {
    back() {
      this.$emit('back');
    },
    sendTransfer() {
      this.$emit('success');
    },
  },
});
